import emailMarketingTable from './_table.js'
import template from './index.pug'

export default Vue.extend({
  template: template(),
  components: {
    emailMarketingTable
  },
  data() {
    return {
      emailMarketing: [],
      meta: {}
    }
  },
  created() {
    this.$setPageTitle(this.$t('emailMarketing.index.title'))
    this.$setBreadcrumbs([
      {label: this.$t('breadcrumbs.emailMarketing.index'), route: {}}
    ])
  },
  methods: {
    loadData(queryOptions = {}) {
      API.emailMarketing.index(queryOptions).then(({data, meta}) => {
        this.emailMarketing = data
        this.meta = meta
      })
    }
  }
})
